// extracted by mini-css-extract-plugin
export default {"container":"AIDrivenSearchUpload_container__ys1nV"};